import {UmpireImage} from '../umpire-image';
import {UmpirePublicationOptions} from '../umpire-publication-options';

export interface UmpireHeroItem extends UmpirePublicationOptions {
  id: string;
  title: string;
  image: Partial<UmpireImage>;
}
